export const allIssues = /* GraphQL */ `
  query ($where: IssueFilterInput, $order: [IssueSortInput!]) {
    allIssues(where: $where, order: $order) {
      edges {
        cursor
        node {
          id
          name
        }
      }
    }
  }
`;
